import { ASSIGNMENT_CACHED_REPOSITORY } from '../core';
import { SUBMISSION_WEB_CACHED, SubmissionWebCached, AssignmentInMemoryWebCached, ASSIGNMENT_CONFIGURATION_CACHED, AssignmentConfigurationCached, ESSAY_ANSWER_DRAFT_WEB_CACHED, EssayAnswerDraftWebCached } from './data-sources';
export var cachedProviders = [{
  provide: SUBMISSION_WEB_CACHED,
  useFactory: function useFactory() {
    return new SubmissionWebCached();
  }
}, {
  provide: ASSIGNMENT_CACHED_REPOSITORY,
  useFactory: function useFactory() {
    return new AssignmentInMemoryWebCached();
  }
}, {
  provide: ASSIGNMENT_CONFIGURATION_CACHED,
  useFactory: function useFactory() {
    return new AssignmentConfigurationCached();
  }
}, {
  provide: ESSAY_ANSWER_DRAFT_WEB_CACHED,
  useFactory: function useFactory() {
    return new EssayAnswerDraftWebCached();
  }
}];